import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services';
import { MovieTicketAmount } from './MovieTicketIcon';

function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState(authService.getCurrentUser());
  const isAuthenticated = authService.isAuthenticated();

  useEffect(() => {
    const syncUser = () => {
      setUser(authService.getCurrentUser());
    };

    const refreshProfile = async () => {
      if (!authService.isAuthenticated()) {
        syncUser();
        return;
      }

      try {
        const profile = await authService.getProfile();
        const current = authService.getCurrentUser() || {};
        authService.setCurrentUser({ ...current, ...profile });
      } catch (error) {
        syncUser();
      }
    };

    window.addEventListener('auth:userUpdated', syncUser);
    window.addEventListener('storage', syncUser);
    refreshProfile();

    return () => {
      window.removeEventListener('auth:userUpdated', syncUser);
      window.removeEventListener('storage', syncUser);
    };
  }, []);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-header">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            <img src="/annapiggy-logo.png" alt="Anna Piggy Logo" className="navbar-logo" />
          </Link>
          
          <div className="menu-icon" onClick={toggleMenu}>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
          </div>
        </div>

        <ul className={isMenuOpen ? 'navbar-links active' : 'navbar-links'}>
          <li><Link to="/playlists" onClick={closeMenu}>网页歌单</Link></li>
          <li><Link to="/marshmallows" onClick={closeMenu}>棉花糖</Link></li>
          {isAuthenticated && user && (
            <>
              <li><Link to="/prizes" onClick={closeMenu}>积分兑换</Link></li>
              <li className="user-points">
                <span>⭐ {user.points || 0} 积分</span>
                <MovieTicketAmount amount={user.movie_tickets || 0} />
                {Number(user.frozen_points || 0) > 0 && (
                  <small>冻结 {user.frozen_points}</small>
                )}
              </li>
              <li><Link to="/profile" onClick={closeMenu}>个人资料</Link></li>
              <li>
                <button onClick={handleLogout} className="btn btn-outline">
                  退出登录
                </button>
              </li>
            </>
          )}
          {!isAuthenticated && (
            <>
              <li><Link to="/login" onClick={closeMenu}>登录</Link></li>
              <li><Link to="/register" onClick={closeMenu}>注册</Link></li>
            </>
          )}
        </ul>

        {isMenuOpen && (
          <div className="navbar-overlay" onClick={closeMenu}></div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
